import React, { useState } from "react";
import CustomModal from "../CustomModal";
import "../CustomModal.css";
import { useGame } from "../../api/copenhunt/v1/copenhunt_rbt_react";
import { LocationInfo_Type } from "../../api/copenhunt/v1/copenhunt_pb";
import { Feature, FeatureCollection, GeoJsonObject } from "geojson";

const AddLocationModal: React.FC<{ gameId: string }> = ({ gameId }) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [geoJson, setGeoJson] = useState<string>("");
  const [locationType, setLocationType] = useState<LocationInfo_Type>(
    LocationInfo_Type.TREASURE
  );

  const {
    mutators: { addLocation },
  } = useGame({ id: gameId });

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  // Function to handle form submission
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const addOneLocation = async (feature: Feature) => {
      if (feature.geometry === undefined) {
        alert("Invalid GeoJSON format (missing geometry). Please try again.");
        return;
      }
      if (feature.geometry.type !== "Polygon") {
        alert("Invalid GeoJSON format (expected Polygon). Please try again.");
        return;
      }

      const json = JSON.stringify(feature);

      const { aborted } = await addLocation({
        geoJson: json,
        type: locationType,
        gameId,
      });
      if (aborted !== undefined) {
        alert("Oh no! That didn't work!");
        return;
      }
    }

    try {
      const geojson_obj = JSON.parse(geoJson) as GeoJsonObject;
      if (geojson_obj === undefined) {
        alert("Invalid GeoJSON format (missing root). Please try again.");
        return;
      }
      if (geojson_obj.type === undefined) {
        alert("Invalid GeoJSON format (missing type). Please try again.");
        return;
      }
      if (geojson_obj.type === "FeatureCollection") {
        const features = (geojson_obj as FeatureCollection).features
        if (features === undefined) {
          alert("Invalid GeoJSON format (missing features). Please try again.");
          return;
        }
        for (const feature of features) {
          await addOneLocation(feature);
        }
      } else {
        console.assert(geojson_obj.type === "Feature");
        await addOneLocation(geojson_obj as Feature);
      }

      setGeoJson("");
      setLocationType(LocationInfo_Type.TREASURE);
      closeModal();
    } catch (error) {
      alert("Invalid GeoJSON format. Please try again.");
    }
  };

  return (
    <div>
      <button onClick={openModal}>Add Locations</button>
      <CustomModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        onSubmit={handleSubmit}
        title="Add Location"
      >
        <div className="modal-form-group">
          <p>Click <a href="https://geojson.io/#new&map=12.56/55.67027/12.55995" target="_blank" rel="noopener noreferrer">here</a> to create GeoJSON.</p>
          <label htmlFor="geoJson">GeoJSON:</label>
          <textarea
            id="geoJson"
            value={geoJson}
            onChange={(e) => setGeoJson(e.target.value)}
            rows={10}
            cols={50}
            className="modal-input"
          />
        </div>
        <div className="modal-form-group">
          <label htmlFor="locationType">Location Type:</label>
          <select
            id="locationType"
            value={locationType}
            onChange={(e) =>
              setLocationType(parseInt(e.target.value) as LocationInfo_Type)
            }
            className="modal-select"
          >
            <option value={LocationInfo_Type.TREASURE}>Treasure</option>
            <option value={LocationInfo_Type.BANK}>Bank</option>
            <option value={LocationInfo_Type.HUNTING_GROUNDS}>
              Hunting Grounds
            </option>
          </select>
        </div>
      </CustomModal>
    </div>
  );
};

export default AddLocationModal;
